module.exports = __webpack_public_path__ + "static/car-pc/img/star-gray-icon.c83157ad.svg";